module.exports = __webpack_public_path__ + "static/media/arrow-goes-left-right-icon.cf29e3ae.svg";